import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { prop } from '../../../utilities';
import { FilterType } from './CategoryFilter';

interface Props {
  isOpen: boolean;
  filterData: any;
  handleFilterChange: (
    type: FilterType,
    newData: { attribId: string; valueId: string; newValue: boolean },
  ) => void;
  activeValues?: string[];
}

const compare = (a, b) => {
  return a.props.selected && !b.props.selected ? -1 : 1;
};
const Sort: any = ({ children }: { children: any }) => {
  return React.Children.toArray(children).sort(compare);
};

function OptionsFilter({
  isOpen,
  filterData,
  handleFilterChange,
  activeValues,
}: Props) {
  const { values } = filterData;
  const handleCheckboxChange = e => {
    const name = e.target.name;
    const [attribId, valueId] = name.split('-');
    const value = e.target.value;
    // const attribId = prop(values[name], 'info.attrib_id');
    handleFilterChange(FilterType.OPTIONS, {
      attribId,
      valueId,
      newValue: value,
    });
  };

  return (
    <>
      {isOpen && (
        <SelectFilterDropdown>
          {values &&
            Object.keys(values).map(key => {
              const value = values[key];
              const valueId = prop(value, 'info.value_id');
              const isActive =
                activeValues && activeValues.includes(valueId.toString());
              const attribValue = prop(value, 'info.attrib_value');
              const attribId = prop(value, 'info.attrib_id');
              const attribLink = prop(value, 'info.attrib_link');

              if (
                (value.doc_count > 0 || isActive) &&
                attribValue &&
                attribValue !== '' &&
                attribValue !== '-'
              ) {
                return (
                  <CheckBox
                    key={valueId}
                    name={`${attribId}-${valueId}`}
                    label={attribValue}
                    type={'checkbox'}
                    selected={isActive}
                    onClick={handleCheckboxChange}
                    wrapperStyle={{ margin: `${rem(8)} 0` }}
                    infoLink={attribLink}
                  />
                );
              }
              return null;
            })}
        </SelectFilterDropdown>
      )}
    </>
  );
}

const FilterDropdown = styled.div`
  
`;

const SelectFilterDropdown = styled(FilterDropdown)`
  max-height: ${rem(288)};
  overflow: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: ${rem(2)};
    border-radius: 2px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.sliderRailColor};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const StyledLabel = styled.label<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  color: ${({ selected, theme }) =>
    selected ? '#1E398D' : theme.colors.textPrimary};
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${rem(8)} 0;
`;

export { OptionsFilter };
